import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useMainBanners() {
    const { data } = useQuery(queries.banners.list('MAIN_1'));
    return data?.banners;
}

export default useMainBanners;
